import { Flex, FloraButton } from '@grupoboticario/flora-react';
import {
  ClockIcon,
  EnvelopeCheckIcon,
  TruckIcon,
  LocationPinIcon,
} from '@grupoboticario/flora-react-icons';
import { Navigate, useNavigate } from 'react-router-dom';

import { ResponsiveFloraTypography } from 'components/ResponsiveFloraTypography';
import config from 'config';
import { useRegistrationControllerContext } from 'store';

import Styles from '../../../Drawers.styles';

export const AddressInformation = () => {
  const navigate = useNavigate();
  const { steps, handleConfirmation } = useRegistrationControllerContext();

  const handleOnClick = () => {
    handleConfirmation();
    navigate('/perfil/editar/endereco/confirmacao', {
      replace: true,
    });
  };

  if (!steps.start || !steps.validate) {
    return <Navigate to='/perfil' replace />;
  }

  return (
    <Styles.DrawerSection>
      <Flex direction='column' gap='$8'>
        <Styles.FullFlex direction='column' gap='$6' justify='center' align='center'>
          <ResponsiveFloraTypography
            fontSize='title'
            css={{ textAlign: 'center' }}
            color='$backgroundAltPrimary'
            fontWeight='medium'
          >
            Antes de continuar, confira as condições:
          </ResponsiveFloraTypography>

          <Flex gap='$2' align='center'>
            <ClockIcon size={28} color='$backgroundAltSecondary' />
            <ResponsiveFloraTypography color='$backgroundAltSecondary'>
              A confirmação de alteração pode ocorrer em até 2 dias úteis.
            </ResponsiveFloraTypography>
          </Flex>

          <Flex gap='$2' align='center'>
            <EnvelopeCheckIcon size={28} color='$backgroundAltSecondary' />
            <ResponsiveFloraTypography color='$backgroundAltSecondary'>
              Atualizações serão enviadas para o e-mail cadastrado no seu perfil.
            </ResponsiveFloraTypography>
          </Flex>

          <Flex gap='$2' align='center'>
            <TruckIcon size={28} color='$backgroundAltSecondary' />
            <ResponsiveFloraTypography color='$backgroundAltSecondary'>
              Só serão emitidas notas fiscais com o novo endereço, após a confirmação de alteração.
              Para pedidos com nota fiscal emitida, o endereço anterior será mantido.
            </ResponsiveFloraTypography>
          </Flex>

          <Flex gap='$2' align='center'>
            <LocationPinIcon size={28} color='$backgroundAltSecondary' />
            <ResponsiveFloraTypography color='$backgroundAltSecondary'>
              O seu{' '}
              <ResponsiveFloraTypography fontWeight='bold'>
                {config.registration.infoResellerPlace}
              </ResponsiveFloraTypography>{' '}
              poderão mudar, de acordo com o novo endereço.
            </ResponsiveFloraTypography>
          </Flex>
        </Styles.FullFlex>
        <FloraButton
          autotagging-flora='on'
          data-flora='button'
          data-flora-text='continuar'
          data-autotagging-flora-section='alterar_endereco'
          onClick={handleOnClick}
        >
          Continuar
        </FloraButton>
      </Flex>
    </Styles.DrawerSection>
  );
};
